
//Naming: "teammate" is kept only where code mirrors backend names
//(api/v1/my_teammate, TeammateConversation) — i.e. this file, the API client
//and the messages-querying composable. Everything user-adjacent is named
//"agent" instead (route /agent, Agent.vue, goToAgent), and user-facing copy
//must never say "teammate": employee-facing = "Arist Agent",
//admin-facing = "Employee Agent".

//Teammate message roles (mirror the api/v1/my_teammate role enum)
export const teammateMessageRoles = {
  USER: 'user',
  ASSISTANT: 'assistant',
}

//Teammate conversation states (mirror TeammateConversation#state)
export const teammateConversationStates = {
  DORMANT: 'dormant',
  ACTIVE: 'active',
  UNRESPONSIVE: 'unresponsive',
}
